import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useSearchResultsTitleContext } from "../context/searchResultsTitle.context";

const SearchTitleComponent = () => {
    const { query } = useSearchResultsTitleContext();
    const { t } = useGranite();

    return (
        <h1>
            {t("search.results.title")}{" "}
            {query !== "" && (
                <span className={cn("tw:font-bold")}>
                    &laquo;{query}&raquo;
                </span>
            )}
        </h1>
    );
};

export { SearchTitleComponent };
